// extracted by mini-css-extract-plugin
export var active = "mainNavigation-module--active--807f6";
export var bounce = "mainNavigation-module--bounce--411c3";
export var btnFacebook = "mainNavigation-module--btn-facebook--fe9f5";
export var btnLinkedin = "mainNavigation-module--btn-linkedin--ece28";
export var btnWechat = "mainNavigation-module--btn-wechat--f9fc9";
export var btnWrap = "mainNavigation-module--btnWrap--b4b4c";
export var btnXing = "mainNavigation-module--btn-xing--b6172";
export var btnYoutube = "mainNavigation-module--btn-youtube--893a7";
export var cameraAccessoriesListingPager = "mainNavigation-module--cameraAccessoriesListingPager--e28c6";
export var container = "mainNavigation-module--container--6ad9e";
export var fadeIn = "mainNavigation-module--fadeIn--84ce8";
export var grid = "mainNavigation-module--grid--dd0ed";
export var hidden = "mainNavigation-module--hidden--ed836";
export var icon = "mainNavigation-module--icon--10787";
export var iconText = "mainNavigation-module--icon-text--776e2";
export var maiNavItemContainer = "mainNavigation-module--maiNavItemContainer--7b6d8";
export var mail = "mainNavigation-module--mail--a2396";
export var mainNavContainer = "mainNavigation-module--mainNavContainer--7ff4c";
export var mainNavWrapper = "mainNavigation-module--mainNavWrapper--1ebb4";
export var mobileMainNav = "mainNavigation-module--mobileMainNav--9b787";
export var mobileTeasers = "mainNavigation-module--mobileTeasers--03ebb";
export var navElementsCommon = "mainNavigation-module--navElementsCommon--7bed1";
export var nestedContentTeaser = "mainNavigation-module--nestedContentTeaser--6829a";
export var newsDetailWrap = "mainNavigation-module--newsDetailWrap--52eee";
export var oneColumn = "mainNavigation-module--oneColumn--3af53";
export var phone = "mainNavigation-module--phone--6354b";
export var phoneNumber = "mainNavigation-module--phoneNumber--1c1ec";
export var printer = "mainNavigation-module--printer--5e6a7";
export var reducedWidth = "mainNavigation-module--reducedWidth--05802";
export var teaserBottomContent = "mainNavigation-module--teaserBottomContent--1a18a";
export var textCap = "mainNavigation-module--textCap--ffe12";
export var twoColumn = "mainNavigation-module--twoColumn--e4164";